import { render, staticRenderFns } from "./Dark.vue?vue&type=template&id=33759606&"
import script from "./Dark.vue?vue&type=script&lang=js&"
export * from "./Dark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports